import { AnimationController, Animation } from '@ionic/angular';

export const slideInAnimation = (
  baseEl: HTMLElement,
  options: { direction: 'enter' | 'leave' }
): Animation => {
  const animationCtrl = new AnimationController();

  const backdropAnimation = animationCtrl
    .create()
    .addElement(baseEl.querySelector('ion-backdrop'))
    .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

  const wrapperAnimation = animationCtrl
    .create()
    .addElement(baseEl.shadowRoot.querySelector('.modal-wrapper'))
    .keyframes([
      { offset: 0, opacity: '0', transform: 'translateX(100%)' },
      { offset: 1, opacity: '0.99', transform: 'translateX(0)' }
    ]);

  return animationCtrl
    .create()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(300)
    .addAnimation([backdropAnimation, wrapperAnimation])
    .direction(options.direction === 'leave' ? 'reverse' : 'normal');
};
